import {VehicleFinancingBalloonPayment} from '@dms/api/sales';

/** Balloon payment brackets a balloon rate matrix can be configured for, in percent. */
export const RATE_MATRIX_BALLOON_BRACKETS: VehicleFinancingBalloonPayment[] = [
  10, 20, 30, 40, 50, 60,
];
